var CustomerIdentifier = {
  isCustomerIdentified: function (pension) {
    const selectionApplications = pension.secondPillar.selectionApplications;
    const submissionApplications = pension.thirdPillar.submissionApplications;
    const customerHasSecondPillar = selectionApplications && selectionApplications.length > 0;
    const customerHasThirdPillar = (submissionApplications && submissionApplications.length > 0) || pension.thirdPillar.assets.length > 0;
    return customerHasSecondPillar || customerHasThirdPillar;
  }
}